import { create } from "zustand";
import type { CustomArt } from "../lib/schedule-art/art-transform";

export type { ArtTransform, CustomArt } from "../lib/schedule-art/art-transform";

type CustomArtState = {
  layers: CustomArt[]; // bottom to top, matching canvas and export order
  selectedId: string | null;
  selectLayer: (imageId: string | null) => void;
};

export const useCustomArtStore = create<CustomArtState>(set => ({
  layers: [],
  selectedId: null,
  selectLayer: selectedId => set({ selectedId }),
}));
